import React, { useState, useEffect } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TablePagination, Paper, Checkbox, Button, TextField, Box
} from '@mui/material';

export default function TableCheckboxSelection({
    data: rows,
    selectedIds,
    setSelectedIds
}) {
    const [search, setSearch] = useState('');
    const [sortField, setSortField] = useState('id');
    const [sortAsc, setSortAsc] = useState(true);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);



    const handleSelect = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
        );
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            const allIds = filteredSortedRows.map((r) => r.id);
            setSelectedIds(allIds);
        } else {
            setSelectedIds([]);
        }
    };


    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSort = (field) => {
        if (sortField === field) {
            setSortAsc(!sortAsc);
        } else {
            setSortField(field);
            setSortAsc(true);
        }
    };

    // Filter
    const filteredRows = rows.filter((row) => {
        const fullName = `${row.subTypeLabel}`.toLowerCase();
        return fullName.includes(search.toLowerCase());
    });

    // Sort
    const filteredSortedRows = [...filteredRows].sort((a, b) => {
        const valA = a[sortField];
        const valB = b[sortField];
        if (valA === null || valA === undefined) return 1;
        if (valB === null || valB === undefined) return -1;
        if (valA < valB) return sortAsc ? -1 : 1;
        if (valA > valB) return sortAsc ? 1 : -1;
        return 0;
    });

    // Paginated Rows
    const paginatedRows = filteredSortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const allSelected = selectedIds.length > 0 && filteredSortedRows.every((row) => selectedIds.includes(row.id));
    const someSelected = selectedIds.length > 0 && !allSelected;

    return (
        <Paper sx={{ p: 0 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <TextField
                    size="small"
                    placeholder="Search by name"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </Box>

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell padding="checkbox">
                                <Checkbox
                                    checked={allSelected}
                                    indeterminate={someSelected}
                                    onChange={handleSelectAll}
                                />
                            </TableCell>
                            <TableCell onClick={() => handleSort('subTypeLabel')} style={{ cursor: 'pointer' }}>#</TableCell>
                            <TableCell onClick={() => handleSort('subTypeLabel')} style={{ cursor: 'pointer' }}>Name</TableCell>
                            <TableCell onClick={() => handleSort('expenseType')} style={{ cursor: 'pointer' }}>Type</TableCell>
                            <TableCell onClick={() => handleSort('quantity')} style={{ cursor: 'pointer' }}>Quantity</TableCell>
                            <TableCell onClick={() => handleSort('unitPrice')} style={{ cursor: 'pointer' }}>Price</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedRows.map((row, index) => {
                            const isSelected = selectedIds.includes(row.id);
                            return (
                                <TableRow key={row.id} selected={isSelected}>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            checked={isSelected}
                                            onChange={() => handleSelect(row.id)}
                                        />
                                    </TableCell>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{row.subTypeLabel}</TableCell>
                                    <TableCell>{row.expenseType}</TableCell>
                                    <TableCell>{row.quantity}</TableCell>
                                    <TableCell>{row.unitPrice ?? '-'}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <TablePagination
                component="div"
                count={filteredSortedRows.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
            />
        </Paper>
    );
}
